<div class="forbidden-container">
  <div class="forbidden-content">
    <div class="forbidden-icon">
      <i class="fas fa-ban"></i>
    </div>
    <h1 class="forbidden-title">การเข้าถึงถูกปฏิเสธ</h1>
    <p class="forbidden-message">
      คุณไม่มีสิทธิ์เข้าถึงหน้านี้
    </p>
    <p class="forbidden-message">
      กรุณาติดต่อผู้ดูแลระบบหากคุณเชื่อว่านี่เป็นข้อผิดพลาด
    </p>
    <p class="forbidden-message">
      กรณีที่ต้องการสมัครเข้าใช้งานระบบตามสอบสินค้าเกษตร บนระบบคลาวด์ ในนามผู้ประกอบการ <a routerLink="/register/verify-thaid" class="font-weight-bold">คลิกที่นี่</a>
    </p>
    <button class="forbidden-logout-button" (click)="logout()">ออกจากระบบ</button>
  </div>
</div>
